import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/VolumeLevel1.svg'

export const IconVolumeLevel1 = IconSVG as IconComponent
